const safeArray = (value):[] => typeof value === 'string' || !value ? [] : value

export {
  safeArray
}